import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface Deal {
  deal_title: string;
  property_address?: string;
  property_type?: string;
  status: string;
}

interface BasicInfoTabProps {
  formData: Deal;
  onChange: (field: keyof Deal, value: any) => void;
}

export function BasicInfoTab({ formData, onChange }: BasicInfoTabProps) {
  return (
    <div className="grid grid-cols-2 gap-4">
      <div className="col-span-2">
        <Label htmlFor="deal_title">Deal Title *</Label>
        <Input
          id="deal_title"
          value={formData.deal_title}
          onChange={(e) => onChange('deal_title', e.target.value)}
          placeholder="Enter deal title"
          required
        />
      </div>
      
      <div className="col-span-2">
        <Label htmlFor="property_address">Property Address</Label>
        <Input
          id="property_address"
          value={formData.property_address || ''}
          onChange={(e) => onChange('property_address', e.target.value)}
          placeholder="123 Main St, City, State ZIP"
        />
      </div>

      <div>
        <Label htmlFor="property_type">Property Type</Label>
        <Input
          id="property_type"
          value={formData.property_type || ''}
          onChange={(e) => onChange('property_type', e.target.value)}
          placeholder="e.g., Single Family Home"
        />
      </div>

      <div>
        <Label htmlFor="status">Status</Label>
        <Input
          id="status"
          value={formData.status}
          onChange={(e) => onChange('status', e.target.value)}
          placeholder="draft"
        />
      </div>
    </div>
  );
}
